import * as React from 'react';
import { StyledHTMLElement } from 'styletron-react';
import { styled } from 'styletron-react';

export const ScreenStyle: React.CSSProperties = {
    cursor: 'default',
    margin: 40,
    position: 'relative',
};

export const Screen = styled('div', ScreenStyle);



// WEBPACK FOOTER //
// ./primitives/Screen.tsx